module.exports = __webpack_public_path__ + "f0517a77ec1754b97fcab977b4a58724.pdf";